/**
 * Compact circular trust badge (0-100) for trending/history cards.
 * Colors: green (≥70), amber (40-69), red (<40).
 */
export default function TrustBadge({ score, size = "sm" }) {
  if (score == null) return null;
  const n = Math.max(0, Math.min(100, Math.round(score)));
  const tone =
    n >= 70 ? "bg-emerald-600 text-white border-emerald-900"
    : n >= 40 ? "bg-amber-500 text-black border-amber-900"
    : "bg-red-600 text-white border-red-900";
  const sizes = {
    sm: "min-w-[44px] px-1.5 py-1 text-[10px]",
    md: "min-w-[56px] px-2 py-1.5 text-xs",
  };
  return (
    <div
      data-testid="trust-badge"
      className={`inline-flex items-center justify-center gap-1 border-2 font-mono-plex font-bold uppercase tracking-wider ${tone} ${sizes[size] || sizes.sm}`}
    >
      <span className="tabular-nums">{n}</span>
      <span className="opacity-80 text-[8px] font-semibold">TRUST</span>
    </div>
  );
}
